export default {
    eigenheim: {
        eigenheimundwohnen_bausparenundbaufinanzierung_bausparvertrag: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18,
                },
                Question2a: {
                    key: 'property',
                    value: 'yes',
                },
                Question3a: {
                    key: 'renovation',
                    value: 'yes',
                },
                Question3b: {
                    key: 'renovation_timing',
                    value: 'not_next_years',
                },
            },
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18,
                },
                Question2a: {
                    key: 'property',
                    value: 'no',
                },
                Question4a: {
                    key: 'property',
                    value: 'yes',
                },
                Question4b: {
                    key: 'property_timing',
                    value: 'not_next_years',
                },
            },
        ],
        eigenheimundwohnen_bausparenundbaufinanzierung_baufinanzierung: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18,
                },
                Question2a: {
                    key: 'property',
                    value: 'yes',
                },
                Question3a: {
                    key: 'renovation',
                    value: 'yes',
                },
                Question3b: {
                    key: 'renovation_timing',
                    value: 'next_years',
                },
            },
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18,
                },
                Question2a: {
                    key: 'property',
                    value: 'no',
                },
                Question4a: {
                    key: 'property',
                    value: 'yes',
                },
                Question4b: {
                    key: 'property_timing',
                    value: 'next_years',
                },
            },
        ],
        eigenheimundwohnen_immobilienversicherung_wohngebaeudeversicherung: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18,
                },
                Question2a: {
                    key: 'property',
                    value: 'yes',
                },
                Question2b: {
                    key: 'value',
                    value: 'house',
                },
            },
        ],
        eigenheimundwohnen_immobilienversicherung_hausratversicherung: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18,
                },
            },
        ],
    },
    alltag: {
        alltagundwuensche_girokonto_psdgiropremium: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 25,
                },
                Question2a: {
                    key: 'value',
                    value: 'mainAccount',
                },
                Question2b: {
                    key: 'value',
                    value: 'local',
                },
            },
        ],
        alltagundwuensche_girokonto_psdgirokomfort: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 25,
                },
                Question2a: {
                    key: 'value',
                    value: 'mainAccount',
                },
                Question2b: {
                    key: 'value',
                    value: 'online',
                },
            },
        ],
        alltagundwuensche_girokonto_psdgirobasic: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 25,
                },
                Question2a: {
                    key: 'value',
                    value: 'secondaryAccount',
                },
            },
        ],
        alltagundwuensche_girokonto_jugendkonto: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age <= 24,
                },
            },
        ],
        alltagundwuensche_karteundratenkredit_classiccard: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18,
                },
                Question3: {
                    key: 'value',
                    value: 'yes',
                },
                Question4: {
                    key: 'value',
                    value: 'no',
                },
            },
        ],
        alltagundwuensche_karteundratenkredit_goldcard: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18,
                },
                Question4: {
                    key: 'value',
                    value: 'yes',
                },
            },
        ],
        alltagundwuensche_karteundratenkredit_konsumkredit: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18,
                },
                Question6: {
                    key: 'value',
                    value: 'yes',
                },
            },
        ],
    },
    absichern: {
        absichernundvorsorgen_grundversicherungen_berufsunfaehigkeitsversicherung: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age <= 45,
                },
                Question4: {
                    key: 'job',
                    value: (job) => [1, 2, 3, 4].includes(parseInt(job)),
                },
            },
        ],
        absichernundvorsorgen_grundversicherungen_unfallversicherung: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18,
                },
            },
        ],
        absichernundvorsorgen_grundversicherungen_risikolebensversicherung: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18 && age <= 50,
                },
                Question2: {
                    key: 'family_status',
                    value: 'couple',
                },
            },
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18 && age <= 50,
                },
                Question3: {
                    key: 'children',
                    value: 'yes',
                },
            },
        ],
        absichernundvorsorgen_grundversicherungen_kreditversicherung: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18,
                },
                Question7: {
                    key: 'value',
                    value: 'yes',
                },
            },
        ],
        absichernundvorsorgen_grundversicherungen_krankenversicherung: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18,
                },
            },
            /*{
                Question1: {
                    key: 'liquidity',
                    value: (liquidity, answers) => {
                        return (
                            answers.Question1.liquidity > 3 * answers.Question2.income &&
                            answers.Question1.liquidity >= 5000
                        );
                    },
                },
                Question4: {
                    key: 'risk_profile',
                    value: (risk) => risk > 0,
                },
                Question5: {
                    key: 'consulting',
                    value: (consulting) => consulting === 'none',
                },
                Question6: {
                    key: 'value',
                    value: (value) => value === 'fonds_and_others' || value === 'dont_know',
                },
            },*/
        ],
        absichernundvorsorgen_altersvorsorge_privaterentenversicherung: [
            {
                Question1: {
                    key: 'age',
                    value: (age) => age >= 18 && age <= 50,
                },
                Question6: {
                    key: 'value',
                    value: 'yes',
                },
            },
        ],
        absichernundvorsorgen_altersvorsorge_riesterundrueruprente: [
            {
                Question4: {
                    key: 'job',
                    value: (job) => [1, 2, 3, 4].includes(parseInt(job)),
                },
            },
            {
                Question4: {
                    key: 'job',
                    value: (job) => [6].includes(parseInt(job)),
                },
                Question5: {
                    key: 'employed_partner',
                    value: 'yes',
                },
            },
        ],
        absichernundvorsorgen_altersvorsorge_betrieblichealtersvorsorge: [
            {
                Question4: {
                    key: 'job',
                    value: (job) => [1, 2, 3].includes(parseInt(job)),
                },
            },
        ],
    },
    sparen: {
        sparenundanlegen_fondssparplan_fondssparplan: [
            {
                Question3: {
                    key: 'reserve',
                    value: (reserve) => parseInt(reserve) >= 50,
                },
                Question4: {
                    key: 'risk_profile',
                    value: (risk) => risk > 0,
                },
                Question5: {
                    key: 'consulting',
                    value: 'none',
                },
            },
        ],
        sparenundanlegen_fondssparplan_vermoegenplusfondssparplan: [
            {
                Question3: {
                    key: 'reserve',
                    value: (reserve) => parseInt(reserve) >= 50,
                },
                Question4: {
                    key: 'risk_profile',
                    value: (risk) => risk > 0,
                },
                Question5: {
                    key: 'consulting',
                    value: 'personal',
                },
            },
        ],
        sparenundanlegen_depot_depot: [
            {
                Question1: {
                    key: 'liquidity',
                    value: (liquidity, answers) => {
                        return (
                            answers.Question1.liquidity > 3 * answers.Question2.income &&
                            answers.Question1.liquidity >= 5000
                        );
                    },
                },
                Question4: {
                    key: 'risk_profile',
                    value: (risk) => risk > 0,
                },
                Question5: {
                    key: 'consulting',
                    value: 'none',
                },
            },
        ],
        sparenundanlegen_depot_vermoegenplus: [
            {
                Question1: {
                    key: 'liquidity',
                    value: (liquidity, answers) => {
                        return (
                            answers.Question1.liquidity > 3 * answers.Question2.income &&
                            answers.Question1.liquidity >= 5000
                        );
                    },
                },
                Question4: {
                    key: 'risk_profile',
                    value: (risk) => risk > 0,
                },
                Question5: {
                    key: 'consulting',
                    value: 'personal',
                },
            },
        ],
    },
};
